import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { AccordionItemComponent } from './accordion-item.component';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [CommonModule, NgClass],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
  @ContentChildren(AccordionItemComponent) itemList!: QueryList<AccordionItemComponent>;

  // When true, multiple items can be open at the same time
  @Input() multiple = false;

  // Rounded option: true | false | 'sm' | 'md' | 'lg' | 'xl'
  @Input() rounded: boolean | 'sm' | 'md' | 'lg' | 'xl' | 'full' = false;

  get items(): AccordionItemComponent[] { return this.itemList?.toArray() ?? []; }
}
